<div class="flex-display font height-100per" aria-label="AICPA">
  <div class="width-70 view-height-overflow">
    <div class="al-left">
      <header class="aicpa-top-heading content-blue" role="heading" aria-level="2" tabindex="0">{{header}}</header>

      <div class="flex-display mb-24px mt-40px info-box">
        <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="GARS Info"></div>
        <label class="ml-8 para-content content-blue" tabindex="0" [innerHTML]="subtext"></label>
      </div>

      <div class="mb-24px mt-40px">
        <label class="para-content font-16" tabindex="0">{{description}}</label>
      </div> 


      <mat-accordion multi class="mb-24px mt-40px">
        <mat-expansion-panel *ngFor="let item of accordiandata">
          <mat-expansion-panel-header class="mataccordianHeader">
            <div class="matheadertext">{{item.header}}</div>
          </mat-expansion-panel-header>

          <div class="list-items-accordion" *ngFor="let link of item.pdflinks">
            <img src="../../../assets/icons/PDF_icon.svg" class="pdf-image" alt="PDF">
            <a class="para-content pdf-link cursor-pointer" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" (keyup.enter)="openLinkById($event)" tabindex="0"><span [id]="link.pdffile.title">{{link.title}}</span></a>
            <span class="content-superseded">{{link.linkText}}</span>&nbsp;
            <img src="../../../assets/icons/new-window-blue.svg" class="pdf-image" alt="Open PDF Attached">
          </div>

        </mat-expansion-panel>
      </mat-accordion>
        


      <div class="mb-24px mt-40px bold">
        <article class="para-content font-16" [innerHTML]="notesHeader" tabindex="0"></article>
      </div>

      <div class="mb-24px">
        <label class="para-content font-16" [innerHTML]="notesBody" tabindex="0"></label>
      </div>

      <div class="mb-24px mt-40px bold">
        <article class="para-content font-16" [innerHTML]="copyrightNoticeHeader" tabindex="0"></article>
      </div>

      <div class="mb-2">
        <label class="para-content font-16" [innerHTML]="copyrightNoticeBody" tabindex="0"></label>
      </div>
    </div>
  </div>

  <div class="right-panel-no-height float-R ">
    <div class="superseded-padding">
      <div class="for-information-on-h pb-16">
        <span class="font-16" [innerHTML]="archiveLibraryBody" tabindex="0"></span>
        <img src="../../../assets/icons/Downloads.svg" class="download-image" alt="download icon">
        <span class="font-16" [innerHTML]="archiveLibraryLink" tabindex="0"></span>
      </div>
    </div>
  </div>
</div>
